import type { LicenseOrderEvent, LicenseOrderStatus } from './types';

function detailTo(detail: LicenseOrderEvent['detail']): string | null {
  if (!detail || typeof detail !== 'object') return null;
  const to = detail.to;
  return typeof to === 'string' ? to : null;
}

function byTime(a: LicenseOrderEvent, b: LicenseOrderEvent): number {
  const cmp = a.at.localeCompare(b.at);
  if (cmp !== 0) return cmp;
  return a.id - b.id;
}

function firstEvent(
  events: LicenseOrderEvent[],
  match: (event: LicenseOrderEvent) => boolean
): LicenseOrderEvent | null {
  const found = events.filter(match).sort(byTime);
  return found[0] ?? null;
}

function lastStateChange(events: LicenseOrderEvent[]): LicenseOrderEvent | null {
  const found = events.filter((event) => event.event === 'state_change').sort(byTime);
  return found.length ? found[found.length - 1]! : null;
}

/** Instante del paso a pagado: state_change, si no el email, si no la columna. */
export function licensePaidAt(input: {
  paidAt: string | null;
  events?: LicenseOrderEvent[] | null;
}): string | null {
  const events = input.events ?? [];
  const change = firstEvent(
    events,
    (event) => event.event === 'state_change' && detailTo(event.detail) === 'paid'
  );
  if (change) return change.at;
  const email = firstEvent(events, (event) => event.event === 'email_paid_sent');
  if (email) return email.at;
  return input.paidAt;
}

/**
 * Instante de la entrega (state_change a delivered).
 * Sin esa transición, «—», aunque la columna traiga la fecha de creación.
 */
export function licenseDeliveredAt(input: {
  status: LicenseOrderStatus;
  deliveredAt: string | null;
  events?: LicenseOrderEvent[] | null;
}): string | null {
  const change = firstEvent(
    input.events ?? [],
    (event) => event.event === 'state_change' && detailTo(event.detail) === 'delivered'
  );
  if (change) return change.at;
  if (input.status === 'delivered') return input.deliveredAt;
  return null;
}

/** Fecha junto al estado: último state_change, o la de creación etiquetada. */
export function licenseHeaderWhen(input: {
  createdAt: string;
  events?: LicenseOrderEvent[] | null;
}): { label: string | null; at: string } {
  const last = lastStateChange(input.events ?? []);
  if (last) return { label: null, at: last.at };
  return { label: 'Creado', at: input.createdAt };
}
